import { useState, useEffect,useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MoreVertical,Pencil,Trash2 } from 'lucide-react'
import DeleteVAPModal from "./DeleteVAPModal";
import EditVAPModal from "./EditVAPModal";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const PodCastDetails = () => {
   const { type, id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null) 
  const [isOpen, setIsOpen] = useState(false);
     // Inside your component
  const dropdownRef = useRef(null)
     useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownIndex(null)
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])
  // console.log("The data is:",data)
   const fetchData = async () => {
 

    try {
      const res = await fetch(`${BASE_URL}/courses/podcast/${id}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      const json = await res.json();
      setData(json);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [type, id]);

    const handleDelete = async (index) => {
  if (!window.confirm(`Are you sure you want to delete this Video`)){
    setOpenDropdownIndex(false)
    return;
  }
    
  try {
    const res = await fetch(`${BASE_URL}/courses/${index}/podcast/resource/delete/`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
    })

    if (res.ok) {
     alert(`Video resource deleted successfully!`);

      setOpenDropdownIndex(false)
      fetchData()
    } else {
      const data = await res.json()
     alert(data.msg || `Failed to delete resource`);

    }
  } catch (err) {
    console.error(err)
    alert(`Error deleting Video resource`);
  } 
}

  if (!data) return null;
  return (
    <>
  <div className="min-h-screen flex justify-center mt-6">
   <div className="max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
    <div className="relative h-[350px]">
                         <video
                            src={data?.file}
                            controls
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute top-4 right-4 flex gap-2">
                            <button
                                onClick={()=>navigate(`/teacher/podcasts/podcast/edit/${data?.id}`)} 
                                className="px-4 py-2 bg-[#0f6abf] text-white rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                                Edit
                            </button>
                            <button
                                onClick={() => setDeleteId(data?.id)} 
                                className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                Delete
                            </button>
                        </div>
                    </div>
               {/* Content */}
                <div className="p-6 space-y-6">
                   {/* Header */}
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-900">{data?.name}</h1>
                        </div>
                    </div>
                     {/* Description */}
                    {data?.description && (
                        <div className="p-4 bg-gray-50 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                                <p className="text-sm font-semibold text-gray-700">Summary</p>
                            </div>
                            <p className="text-gray-600">{data?.description}</p>
                        </div>
                    )}
                     {/* Info Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="bg-gray-50 p-4 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                     <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
        </svg>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 mb-1">Category</p>
                            <p className="font-medium text-gray-900">{data.category_name}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l5 5a2 2 0 01.586 1.414V19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z" />
        </svg>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 mb-1">SubCategory</p>
                            <p className="font-medium text-gray-900">{data.subcategory_name}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 mb-1">Price</p>
                            <p className="font-medium text-gray-900"> {data.course_type === "paid" ? `${data.price}` : "Free"}</p>
                        </div>
                    </div>
 {/* Reference Files */}
                    <div className="border-t border-gray-100 pt-6">
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-semibold text-gray-900">Reference Files</h2>
                                    <p className="text-sm text-gray-500 mt-0.5">Attached documents and resources</p>
                                </div>
                            </div>
                            {/* <button
                                onClick={addReference}
                                className="px-4 py-2 bg-[#0f6abf] text-white rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                </svg>
                                Add New Reference
                            </button> */}
                        </div>
                        {data?.resources?.length === 0 ? (
                            <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
                                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-medium text-gray-700 mb-2">No reference files</h3>
                                <p className="text-sm text-gray-500">Add reference files to this video</p>
                            </div>
                        ) : (
                            <div className="space-y-3">
                                {data.resources.map((resource, index) => (
                                    <div
                                        key={index}
                                        className="flex flex-col md:flex-row md:justify-between md:items-center bg-gray-50 p-4 rounded-xl gap-4"
                                    >
                                        <div className="flex items-center gap-3 w-full">
                                            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                                                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                    />
                                                </svg>
                                            </div>
                                            <div className="flex-1 min-w-0 break-words">
                                                <a
                                                    href={resource.file}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="font-medium text-blue-600 underline hover:text-blue-800"
                                                >
                                                    {resource.file.split("/").pop()} {/* Shows just the filename */}
                                                </a>
                                                {/* <p className="text-xs text-gray-500 uppercase mt-0.5">
                                                    {file.publication_type}
                                                </p> */}
                                            </div>
                                            {/* Three vertical dots at the end */}
                                            <div className="relative flex-shrink-0 ml-2">
                                                <MoreVertical size={18} onClick={() => setOpenDropdownIndex(openDropdownIndex === resource.id ? null : resource.id)} className=" cursor-pointer" />
                                                {
                                                    openDropdownIndex === resource.id && (
                                                        <div ref={dropdownRef} className="absolute top-9 right-0 bg-white border border-gray-300 rounded-lg flex flex-col min-w-[120px] z-[1000]">
                                                            <button
                                                               onClick={() => setIsOpen(true)}
                                                                className="px-3 py-2 flex items-center gap-1.5 text-sm rounded-md hover:bg-gray-100 cursor-pointer transition-colors duration-200 ease-in-out"
                                                                title="Edit"
                                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                            >
                                                                <Pencil size={14} /> Edit
                                                            </button>
                                                            <button
                                                                onClick={() => handleDelete(resource.id)}
                                                                className="px-3 py-2 flex items-center gap-1.5 text-sm rounded-md hover:bg-gray-100 cursor-pointer transition-colors duration-200 ease-in-out"
                                                                title="Delete"
                                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <Trash2 size={14} /> Delete
                                                            </button>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>

                                ))}
                            </div>
                        )}
                    </div>
                </div>


  </div>
</div>
      <DeleteVAPModal deleteId={deleteId} setDeleteId={setDeleteId} type={data?.learning_type} />
       <EditVAPModal id={openDropdownIndex} type={type} open={isOpen} setOpen={setIsOpen} fetchData={fetchData}/>
    </>
  );
}



export default PodCastDetails